module.exports = __webpack_public_path__ + "560eede2b40f0d4e5675e0e6208b114d.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/favicon.png
// module id = 1VYK
// module chunks = 13